// Boundary to the Tether WDK worker. Main-thread code must call through
// `walletCall` only — never postMessage the worker directly, never import
// its internals.
import TetherWorker from '../workers/tether.worker.js?worker';
import { createRpcClient } from './worker-rpc.js';

const worker = new TetherWorker();
export const walletCall = createRpcClient(worker);
